<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

<!--    <site-query :sites="filterSites" :query="query" />-->
    <el-cascader
      v-model="siteDevice"
      size="small"
      :options="filterSites"
      :show-all-levels="false"
      :props="props"
      placeholder="请选择站房设备"
      @change="onSearchBtnClick"
    />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox
      v-if="query.isAuditCompleted !== false"
      v-model="query.isMultipleIntegral"
      label="重积分"
      size="small"
      border
    /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <unit-switch
          :default-unit-prop.sync="unitProp"
          @change="onUnitPropChange"
        />

        <el-radio-group v-if="components.length > 1" v-model="componentId" size="small" @change="onComponentIdChange">
          <el-radio-button
            v-for="(component, index) in components"
            :key="index"
            :label="index"
          >{{component.name}}</el-radio-button>
        </el-radio-group>

        <factor-tree-query
          v-if="currentSiteDevice && component"
          ref="factor-tree"
          :factor-tree="siteDeviceFactors"
          :query="factorQuery"
          :disabled="component.disabledFactorSelect"
        />
      </template>

      <template v-if="dataList.length > 0">
        <div
          v-for="siteData in dataList"
          :key="siteData.id"
          class="root-chart-wrapper"
        >
          <div class="root-chart-header">
            <span data-v-5ce3d8fe="">{{siteData.name}}</span>
          </div>

          <div class="root-chart-body">
            <div
              v-for="(data, factorId) in siteData.dataMap"
              v-if="component.disabledFactorSelect || selectedFactorIdMap[factorId]"
              :key="factorId"
              class="root-chart-item"
            >
              <div class="root-chart-item-header">{{data.name}}</div>
              <div>
                <polar-contour
                  :unit="data.unit"
                  :dataList="data.dataList"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <div v-else></div>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import FactorTreeQuery from '../../../../components/Data/Query/FactorTreeQuery'
import unitConverter from '../../../../utils/unitConverter'
import PolarContour from '../../../../components/PolarContour/index'

export default {
  name: 'StatisticalAnalysisVOCsRoot',
  routeInfo: {
    label: '溯源分析',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, UnitSwitch, FactorTreeQuery, PolarContour},
  data: () => ({
    query: {
      isFuse: false,
      isGetInvalidData: true,
      isMultipleIntegral: true
    },
    componentId: 0,
    siteDevice: [],
    factorQuery: {
      factorIds: []
    },
    currentSiteDevice: null,
    props: {
      children: 'devices',
      value: 'id',
      label: 'name'
    }
  }),
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NMHC_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HCHO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PAN_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.OCEC_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HEAVY_METAL_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.SPAMS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.BLACK_CARBON_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.LIGHT_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ORGANIC_SULFUR_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.GONG_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PARTICLE_SIZE_SPECTRUM_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO2_DIRECT_DETECTION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NOY_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO2_DIRECT_DETECTION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NOY_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.SUN_RADIATION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.GREENHOUSE_GAS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ULTRAVIOLET_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PHOTOLYSIS_RATE_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NEGATIVE_OXYGEN_ION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.METEOROLOGICAL_DEVICE_CATEGORY, true, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => /^101(|2|3)$/.test(siteDeviceFactor.factorId)))
      ]
    },
    requiredFactorIds: () => ['1012', '1013'],
    filterSites () {
      const sites = JSON.parse(JSON.stringify(this._filterSites))

      sites.forEach(site => {
        site.devices = site.devices.filter(device => device.categoryId !== process.env.METEOROLOGICAL_DEVICE_CATEGORY)
      })

      return sites
    },
    isSetUnit: () => true,
    isSetAllFactorIds: () => false,
    _filterFactorMap () {
      return this.filterSites.reduce((map, {devices}) => devices.reduce((map, device) => device.siteDeviceFactors.reduce((map, deviceFactor) => {
        let {factorId} = deviceFactor

        if (!/^101(2|3)$/.test(factorId) && !map[factorId]) {
          let newDeviceFactor = JSON.parse(JSON.stringify(deviceFactor))
          newDeviceFactor.id = factorId
          map[factorId] = newDeviceFactor
        }

        return map
      }, map), map), {})
    },
    components () {
      const components = []
      const {currentSiteDevice} = this

      if (currentSiteDevice) {
        if (currentSiteDevice.categoryId === process.env.VOCS_DEVICE_CATEGORY) {
          components.push({
            id: 0,
            name: 'VOCs总量',
            disabledFactorSelect: true,
            apis: ['getVOCCategoryData', 'getVOCsOFPTotal'],
            ofpText: '',
            formatter: ([totalList, ofpList], vocs, factorIds) => {
              totalList.reduce((map, data) => {
                let {siteId} = data
                let siteDataMap = map[siteId]

                if (!siteDataMap) {
                  siteDataMap = map[siteId] = {}
                }

                let {dataTime} = data
                let newData = siteDataMap[dataTime]

                if (!newData) {
                  newData = siteDataMap[dataTime] = {
                    dataTime,
                    siteId,
                    factorId: 'VOCs浓度总量',
                    value: 0
                  }

                  vocs.push(newData)
                }

                newData.value += data.value

                return map
              }, {})

              let ofpListLen = ofpList.length

              for (let i = 0; i < ofpListLen; i++) {
                let data = ofpList[i]
                vocs.push({
                  dataTime: data.dataTime,
                  siteId: data.siteId,
                  factorId: 'VOCs OFP总量',
                  value: data.ofp
                })
              }

              return [...factorIds, 'VOCs浓度总量', 'VOCs OFP总量']
            }
          }, {
            id: 1,
            name: 'VOCs组分类别',
            disabledFactorSelect: true,
            ofpText: '',
            apis: ['getVOCCategoryData'],
            formatter: ([dataList], vocs, factorIds) => {
              let factorIdMap = {}
              let dataListLen = dataList.length

              for (let i = 0; i < dataListLen; i++) {
                let data = dataList[i]
                let {groupName} = data

                vocs.push({
                  dataTime: data.dataTime,
                  siteId: data.siteId,
                  factorId: groupName,
                  value: data.value
                })

                factorIdMap[groupName] = true
              }

              return [...factorIds, ...Object.keys(factorIdMap)]
            }
          }, {
            id: 2,
            name: '单因子OFP',
            disabledFactorSelect: false,
            ofp: true,
            ofpText: ' OFP'
          })
        }

        components.push({
          id: 3,
          name: '单因子',
          disabledFactorSelect: false,
          ofpText: ''
        })
      }

      return components
    },
    component () {
      const {componentId} = this
      return this.components.find(component => component.id === componentId)
    },
    siteDeviceFactors () {
      const {currentSiteDevice} = this
      return currentSiteDevice ? currentSiteDevice.siteDeviceFactors.map(siteDeviceFactor => ({
        id: siteDeviceFactor.factorId,
        name: siteDeviceFactor.name
      })) : []
    },
    selectedFactorIdMap () {
      return this.factorQuery.factorIds.reduce((map, factorId) => {
        map[factorId] = true
        return map
      }, {})
    }
  },
  methods: {
    setCurrentQuery () {
      let {component} = this
      let currentQuery = JSON.parse(JSON.stringify(this.query))

      if (component.disabledFactorSelect) {
        currentQuery.factorIds = [...this.requiredFactorIds]
      } else {
        currentQuery.factorIds.push(...this.requiredFactorIds)
      }

      this.currentQuery = Object.freeze(currentQuery)
    },
    getData () {
      this.changeLoadStatus(true)

      let requests = [
        this.$api.Data.getHistoryData(this.currentQuery)
      ]
      const {apis} = this.component

      if (Array.isArray(apis) && apis.length > 0) {
        apis.forEach(api => {
          requests.push(this.$api.Data[api](this.currentQuery))
        })
      }

      Promise.all(requests).then(this.setDataList).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setDataList (dataList) {
      let {component} = this
      let {siteIds, factorIds} = this.currentQuery
      factorIds = factorIds.slice(0, factorIds.length - 2)

      let siteWindMap = siteIds.reduce((map, siteId) => {
        map[siteId] = {}
        return map
      }, {})
      let windIdMap = this.requiredFactorIds.reduce((map, factorId, index) => {
        map[factorId] = index + 1
        return map
      }, {})

      let vocs = []

      if (dataList.length > 1) {
        let winds = dataList[0]
        let windLen = winds.length
        for (let i = 0; i < windLen; i++) {
          let data = winds[i]
          let {siteId} = data
          let siteData = siteWindMap[siteId]

          if (siteData) {
            let {dataTime} = data
            let speedDir = siteData[dataTime]

            if (!speedDir) {
              speedDir = siteData[dataTime] = new Array(2)
            }

            speedDir[windIdMap[data.factorId] - 1] = data.value
          }
        }

        factorIds = component.formatter(dataList.slice(1), vocs, factorIds)
      } else {
        dataList = dataList[0]
        let {length} = dataList

        for (let i = 0; i < length; i++) {
          let data = dataList[i]
          let {factorId} = data

          if (windIdMap[factorId]) {
            let {siteId} = data
            let siteData = siteWindMap[siteId]

            if (siteData) {
              let {dataTime} = data
              let speedDir = siteData[dataTime]

              if (!speedDir) {
                speedDir = siteData[dataTime] = new Array(2)
              }

              speedDir[windIdMap[data.factorId] - 1] = data.value
            }
          } else {
            vocs.push(data)
          }
        }
      }

      siteWindMap = Object.fromEntries(Object.entries(siteWindMap).map(([siteId, speedDir]) => [siteId, Object.fromEntries(Object.entries(speedDir).filter(([dataTime, data]) => Number.isFinite(data[0]) && Number.isFinite(data[1])))]))
      this.factorIds = Object.freeze(factorIds)
      this.tmpList = Object.freeze([siteWindMap, vocs.filter(data => {
        let windDirMap = siteWindMap[data.siteId]
        return windDirMap && windDirMap[data.dataTime]
      })])

      this.formatDataList()
    },
    formatDataList () {
      let {factorIds, siteFactorMap, tmpList: [siteWindMap, vocs], filterSiteMap, factorMap, component, unitProp} = this
      let {ofp, disabledFactorSelect, ofpText} = component
      let factors = this.currentSiteDevice.siteDeviceFactors
      let dataMap = this.currentQuery.siteIds.reduce((map, siteId) => {
        let site = filterSiteMap[siteId]
        map[siteId] = {
          id: siteId,
          name: site.name,
          dataMap: factorIds.reduce((map, factorId) => {
            let site = siteFactorMap[siteId]

            if (site && (disabledFactorSelect || site.map[factorId])) {
              let factor = factorMap[factorId]

              if (ofp) {
                if (factor.mir) {
                  map[factorId] = {
                    name: `${factor.name}${ofpText}`,
                    unit: factor[unitProp],
                    dataList: []
                  }
                }
              } else {
                map[factorId] = {
                  name: `${factor ? factor.name : factorId}${ofpText}`,
                  unit: factor ? factor[unitProp] : factors[0][unitProp],
                  dataList: []
                }
              }
            }

            return map
          }, {})
        }

        return map
      }, {})

      let vocsLen = vocs.length

      for (let i = 0; i < vocsLen; i++) {
        let data = vocs[i]
        let {siteId} = data
        let windMap = siteWindMap[siteId]

        if (windMap) {
          let {dataTime} = data
          let windData = windMap[dataTime]

          if (windData) {
            let {factorId} = data
            let factorData = dataMap[siteId].dataMap[factorId]

            if (factorData) {
              let {value} = data
              let factor = factorMap[factorId]

              if (factor) {
                value = unitConverter(value, factor.stdUnit, factor[unitProp], factor.molecular)

                if (ofp) {
                  value *= factor.mir
                }
              }

              factorData.dataList.push([windData[0], windData[1], Number(value.toFixed(3))])
            }
          }
        }
      }

      this.dataList = Object.freeze(Object.values(dataMap))
    },
    onComponentIdChange () {
      this.afterSetSiteIds()
    },
    onUnitPropChange () {
      if (this.component.disabledFactorSelect) {
        this.afterSetSiteIds()
      } else {
        this.formatDataList()
      }
    },
    setSiteIds () {
      let {filterSites} = this

      if (filterSites.length === 0) {
        return
      }

      let {query: {siteIds}} = this

      if (siteIds.length === 0) {
        siteIds.push(...filterSites.slice(0, this.minSiteSelectNumber).map(site => site.id))
        this.siteDevice = [filterSites[0].id, filterSites[0].devices[0].id]
      }

      this.afterSetSiteIds()
    },
    onCheck () {
      let {filterSiteMap, siteDevice, query} = this
      let siteId = siteDevice[0]
      let siteDevices = filterSiteMap[siteId].devices
      query.siteIds = [siteId]
      this.currentSiteDevice = siteDevices.find(el => el.id === siteDevice[1])
      let factors = this.currentSiteDevice.siteDeviceFactors
      query.factorIds = factors.map(el => el.factorId)
      query.unit = factors && factors.length > 0 ? factors[0][this.unitProp] : ''

      if (!this.component) {
        this.componentId = this.components[0].id
      }

      if (!this.component.disabledFactorSelect) {
        this.factorQuery.factorIds = [...query.factorIds]

        setTimeout(() => {
          this.getFactorTree().setCheckedKeys(query.factorIds)
        }, 0)
      }
    },
    afterSetSiteIds () {
      if (this.setOther()) {
        this.onCheck()
        this.setCurrentQuery()
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.root-chart-wrapper {
  .root-chart-header {
    display: grid;
    grid-template-columns: auto max-content;
    width: 100%;
    height: 1.8em;
    line-height: 1.8em;
    padding: 0 10px;
    color: #ffffff;
    background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
    font-weight: 600;
  }

  .root-chart-body {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .root-chart-item {
    display: grid;
    grid-template-rows: 30px auto;
    flex: 1 1 600px;
    height: 298px;

    > * {
      min: {
        width: 0;
        height: 0;
      }
    }

    > .root-chart-item-header {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/00Root/index.vue